module.exports = __webpack_public_path__ + "static/media/facebook.9e285c2f.svg";